"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SyncService", {
    enumerable: true,
    get: function() {
        return SyncService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _catchError = require("~/helpers/catchError");
const _PagedResponse = require("~/helpers/PagedResponse");
const _models = require("~/models");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let SyncService = class SyncService {
    async syncSourceList(context, param) {
        return new _PagedResponse.PagedResponseImpl(await _models.SyncSource.list(context, param.baseId, param.sourceId));
    }
    async syncCreate(context, param) {
        const base = await _models.Base.getWithInfo(context, param.baseId);
        const sync = await _models.SyncSource.insert(context, _extends({}, param.syncPayload, {
            fk_user_id: param.userId,
            source_id: param.sourceId ? param.sourceId : base.sources[0].id,
            base_id: param.baseId
        }));
        this.appHooksService.emit(_nocodbsdk.AppEvents.SYNC_SOURCE_CREATE, {
            syncSource: sync,
            req: param.req,
            context
        });
        return sync;
    }
    async syncDelete(context, param) {
        const syncSource = await _models.SyncSource.get(context, param.syncId);
        if (!syncSource) {
            _catchError.NcError.get(context).badRequest('Sync source not found');
        }
        const res = await _models.SyncSource.delete(context, param.syncId);
        this.appHooksService.emit(_nocodbsdk.AppEvents.SYNC_SOURCE_DELETE, {
            syncSource,
            req: param.req,
            context
        });
        return res;
    }
    async syncUpdate(context, param) {
        const syncSource = await _models.SyncSource.get(context, param.syncId);
        if (!syncSource) {
            _catchError.NcError.get(context).badRequest('Sync source not found');
        }
        const res = await _models.SyncSource.update(context, param.syncId, param.syncPayload);
        this.appHooksService.emit(_nocodbsdk.AppEvents.SYNC_SOURCE_UPDATE, {
            syncSource,
            req: param.req,
            context
        });
        return res;
    }
    constructor(appHooksService){
        this.appHooksService = appHooksService;
    }
};
SyncService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService
    ])
], SyncService);
